import { render, staticRenderFns } from "./ExtractedData.vue?vue&type=template&id=6dc34fb8"
import script from "./ExtractedData.vue?vue&type=script&lang=js"
export * from "./ExtractedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports